var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 12.4811L9.02444 10.5067M11 12.4811L12.9756 10.5067M11 12.4811V6.55556M15.4444 13.4689C15.4444 13.9928 15.2363 14.4953 14.8658 14.8658C14.4953 15.2363 13.9928 15.4444 13.4689 15.4444H8.53111C8.00716 15.4444 7.50467 15.2363 7.13418 14.8658C6.76369 14.4953 6.55556 13.9928 6.55556 13.4689M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Download.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = Download;

Download.default = Download;
